import { getReportHeaders } from "@adapters/infrastructures/urlConfig/Reports/reportHeaders";
import urlConfig from "@adapters/infrastructures/urlConfig/Reports/reportsUrl";
import { DPIdsMapper, DPTransactionMapper, } from "@domains/mapper/Reports/DpTransactionReport";
import { getIsInIFrame } from "@domains/utils/tokenParser";
class DPTransactionReportRepository {
    constructor(http, accountDetails) {
        this.http = http;
        this.accountDetails = accountDetails;
    }
    async getDPTransactionHistory(requestData) {
        const accountCode = await this.accountDetails.getAccountCode();
        const url = new URL(urlConfig.dpTransactionHistory);
        url.searchParams.append("accountCode", accountCode);
        url.searchParams.append("fromDate", requestData.fromDate);
        url.searchParams.append("toDate", requestData.toDate);
        url.searchParams.append("status", "ALL");
        url.searchParams.append("dpid", requestData.dpid);
        const dpTransactionReportData = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
            headers: getReportHeaders(accountCode),
            avoidAuthToken: getIsInIFrame(),
        });
        // const dpTransactionReportData = dummyDPTransaction;
        const dpTransactionEntity = DPTransactionMapper(dpTransactionReportData === null || dpTransactionReportData === void 0 ? void 0 : dpTransactionReportData.data);
        return dpTransactionEntity;
    }
    async submitSpecificRequest(requestData) {
        const url = new URL(urlConfig.dpTransactionSubmit);
        const dpTransactionReportData = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            headers: getReportHeaders(requestData.accountCode),
            body: requestData,
            avoidAuthToken: getIsInIFrame(),
        });
        return dpTransactionReportData.data;
    }
    async getDpIds(accCode) {
        let accountCode;
        if (accCode)
            accountCode = accCode;
        else
            accountCode = await this.accountDetails.getAccountCode();
        const url = new URL(urlConfig.dpIds);
        url.searchParams.append("accountId", accountCode);
        const dpTransactionReportData = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
            headers: getReportHeaders(accountCode),
            avoidAuthToken: getIsInIFrame(),
        });
        return DPIdsMapper(dpTransactionReportData.data);
    }
    async getDpPullEmail(req) {
        let url = new URL(urlConfig.dpURL + "/email");
        const accountCode = await this.accountDetails.getAccountCode();
        let resp = await this.http.makeApiCall({
            method: "POST",
            headers: getReportHeaders(accountCode),
            url: url.toString(),
            body: req,
            avoidAuthToken: getIsInIFrame(),
        });
        return resp.data.status;
    }
}
export default DPTransactionReportRepository;
